module.exports = __webpack_public_path__ + "static/media/student-snapshort2-side.58c1b086.png";